import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div<{ disabled?: boolean }>`
	display: flex;
	flex-direction: column;
	height: 100%;
	border-radius: 12px;
	background-color: ${tokens.color_gray_light};

	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

	img {
		width: 100px;
		margin-top: -40px;
		align-self: center;
	}
`;

export const Title = styled.div`
	display: flex;
	align-items: end;

	height: 140px;
	padding: 0 0 10px 20px;

	font-style: normal;
	font-weight: 600;
	font-size: 16px;
	line-height: 22px;
	color: ${tokens.color_gray_dark};
`;

export const Text = styled.div<{ disabled?: boolean }>`
	display: flex;
	align-items: center;
	border-bottom-left-radius: 12px;
	border-bottom-right-radius: 12px;

	height: 120px;
	padding: 0 20px;
	background-color: ${({ disabled }) =>
		disabled ? tokens.color_gray_medium : tokens.color_white};

	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 22px;
	color: ${tokens.color_gray_dark};
`;
